import { Namespace, TFunction } from 'react-i18next';

export const navigationSettingsModalId = 'navigation-settings-modal';

export interface PresetNavigationRow {
  key: string;
  name: string;
  url: string;
  titleFieldName?: 'bookNowTitle';
}

export const getPresetNavigationRows = (
  t: TFunction<Namespace<'en'>>,
  websiteUrl?: string | null,
): PresetNavigationRow[] => {
  const website = websiteUrl?.replace(/\/$/, '') ?? '';

  return [
    {
      key: 'home',
      name: t('pageDirectBookingEngine.navigationSettings.presetHome'),
      url: website,
    },
    {
      key: 'bookNow',
      name: t('pageDirectBookingEngine.navigationSettings.presetBookNow'),
      url: website ? `${website}/search` : '',
      titleFieldName: 'bookNowTitle',
    },
  ];
};
